<template>
  <div class="navigation">
    <!-- logo -->
    <router-link to="/">
      <div class="logo">
        <div><img src="@/assets/images/logo.png" alt="" /></div>
        <div>{{ title }}</div>
      </div>
    </router-link>

    <!-- 菜单 -->
    <nav-menu />

    <!-- 客服 -->
    <div class="service">
      <img src="@/assets/images/mascot.png" alt="" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import navMenu from "./nav-menu.vue";
export default {
  name: "navigation",
  components: {
    navMenu,
  },
  computed: {
    ...mapState("settings", ["title"]),
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  width: 100%;
  height: $navigation-height;
  @include crosswise;
  padding: 0 80px 0 160px;
  @include absolute-positioning(fixed);
  z-index: 20;
  background-color: $bg-color1;
  border-bottom: 1px solid #b9b8b877;

  .logo {
    @include inheritWH(auto);
    @include crosswise;
    align-items: center;

    & > div:first-child {
      @include inheritWH(46px, 43px);
      margin-right: 20px;
    }

    & > div:last-child {
      font-weight: 600;
      font-size: 25px;
    }
  }

  .service {
    @include inheritWH(120px,90px);
    cursor: pointer;
    display: flex;
    margin: 10px 0 0 0;
  }
}
</style>
